import { environment } from '@env/environment';

export const SSBD_HTTP_503 = {
  HTTP_STATUS: 503,
  STATUS_TEXT: 'Service Temporarily Unavailable',
  MODAL_TIMEOUT_MS: 15000,
} as const;

export const SSBD_HTTP_503_MICRO_BASES: string[] = [
  environment.urlApi,
  environment.urlApiMicro,
  environment.urlApiCheckin,
  environment.urlApiMyTrips,
  environment.urlApiCheckinBFF,
  environment.urlApiPaymentBFF,
  environment.urlApiAncillariesBFF,
  environment.urlApiMicroEligibility,
  environment.urlApiContactability,
  environment.urlApiContactabilityAuth,
  environment.urlApiSelfReaccom,
  environment.urlApiAncillary,
  environment.urlAncillaries,
  environment.urlApiPayment,
  environment.urlApiWeb,
  environment.apiAWS,
  environment.urlApiLoyal,
  '/kiosk/checkin/flightstatus',
].filter((base): base is string => Boolean(base));
